<template>
    <div>
        <router-view/>
    </div>
</template>
<script>
export default {
    name:'mobile_myInfo',
    props:{

    }       
    ,
    data(){
        return{

        }
    },
    mixins:[

    ],
    components:{

    },
    mounted() {
    },
    methods:{
    }
}
</script>
<style lang="scss" scoped>
</style>